import axios from "@/repositories/client";

axios.getHotels = (query, pagination) => {

  let options = {
    params: {
      search: query,
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/hotels`, options)
    .then(response => {
      return response.data;
    });
};

axios.getHotel = (id) => {
  return axios.get(`athena/v1/hotels/${id}`)
    .then(response => {
      return response.data.data;
    });
};

axios.saveHotel = (hotel) => {
  let url = `athena/v1/hotels` + (hotel.id ? `/${hotel.id}` : '');
  let verb = hotel.id ? 'PUT' : 'POST';

  return axios.request({method: verb, url: url, data: hotel})
    .then(response => {
      return response.data.data;
    });
};



export default axios;